import classNames from 'classnames';
import React      from 'react';

const TradeStoreSliderIconNext = function(props) {
  const {
          disabled,
          onClick,
        } = props;

  return (
    <svg
      onClick={onClick}
      className={classNames('swiper_button_next', { disabled })}
      width="18"
      height="18"
      viewBox="18 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M36 9L22.5 16.7942V1.20577L36 9Z" fill="#D9D9D9" />
    </svg>
  );
};

export default TradeStoreSliderIconNext;